import { Button, Checkbox, Grid, Paper, Typography } from "@mui/material";
import { IBatch } from "../../animals/interface";

interface IBatchItem {
  batch: IBatch;
  checked: boolean;
  onChange: (batch: IBatch, checked: boolean) => void;
}

export const BatchItem: React.FC<IBatchItem> = ({
  batch,
  checked,
  onChange,
}) => {
  return (
    <Paper
      component={Button}
      sx={{ py: 1, px: 2, bgcolor: "grey.50" }}
      elevation={0}
      onClick={(_) => {
        onChange(batch, !checked);
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item md>
          <Typography
            sx={{
              fontSize: 14,
              textAlign: "left",
              fontWeight: "bold",
              color: "primary.main",
            }}
          >
            {batch.name}
          </Typography>
        </Grid>
        <Grid item md={false}>
          <Checkbox checked={checked} />
        </Grid>
      </Grid>
    </Paper>
  );
};
